// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*layout*/
#main_contents{
    width: 100%;
    height: 869px;
    background: #FFF;
    -webkit-backdrop-filter: blur(50px);
            backdrop-filter: blur(50px);
}


.wrap{display: flex;}

.wrap .loading{
    position:absolute; top:0; left:0;
    background: rgba(0,0,0,0.35);
    margin: -20px -30px;
    padding: 20px 30px;
    width:100%;
    height: 100%;
    z-index: 999;
    pointer-events:'none';
}

.wrap .loading p {
    position: inherit;
    top:50%;
    left:50%;
    font-size: 30px;
    font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/pages/layout.css"],"names":[],"mappings":"AAAA,SAAS;AACT;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mCAAmC;YAC3B,2BAA2B;AACvC;;;AAGA,MAAgD,aAAa,CAAC;;AAE9D;IACI,iBAAiB,EAAE,KAAK,EAAE,MAAM;IAChC,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,OAAO;IACP,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["/*layout*/\n#main_contents{\n    width: 100%;\n    height: 869px;\n    background: #FFF;\n    -webkit-backdrop-filter: blur(50px);\n            backdrop-filter: blur(50px);\n}\n\n\n.wrap{display: -webkit-box;display: -ms-flexbox;display: flex;}\n\n.wrap .loading{\n    position:absolute; top:0; left:0;\n    background: rgba(0,0,0,0.35);\n    margin: -20px -30px;\n    padding: 20px 30px;\n    width:100%;\n    height: 100%;\n    z-index: 999;\n    pointer-events:'none';\n}\n\n.wrap .loading p {\n    position: inherit;\n    top:50%;\n    left:50%;\n    font-size: 30px;\n    font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
